"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getEventActivity = exports.searchOverdueEvents = exports.getEventsExport = exports.changeStatus = exports.addUpload = exports.addComment = exports.getEvent = exports.setSelectedEvent = exports.patchEvent = exports.addEvent = exports.getAnalytics = exports.searchEvents = exports.resetNewEvents = exports.getServerSentEvents = void 0;

var _apiServices = require("@pingum/api-services");

var _eventSourcePolyfill = require("event-source-polyfill");

var _tenantHelper = require("../util/tenantHelper");

var types = _interopRequireWildcard(require("./types"));

var _networkDispatcher = require("../networkDispatcher");

var _allEventsDashboard = _interopRequireDefault(require("../dashboard/allEventsDashboard"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var eventSource = null;
var reconnectAttempt = 0;
var currentSseTenant = '';
var currentRequest = {};
var currentPage = 0;
var currentSize = 50;
var currentSortStartDateDesc = true;

var isStringJson = function isStringJson(str) {
  try {
    JSON.parse(str);
  } catch (e) {
    return false;
  }

  return true;
};

var dispatchSearchEvents = function dispatchSearchEvents(dispatch, request, page, size, sortStartDateDesc) {
  return (0, _networkDispatcher.dispatchNetworkRequest)({
    dispatch: dispatch,
    requestType: types.EVENT_SEARCH_REQUESTED,
    successType: types.EVENT_SEARCH_SUCCESS,
    errorType: types.EVENT_SEARCH_ERROR,
    promise: _apiServices.EventService.searchEvents(request, page, size, sortStartDateDesc),
    defaultErrorMessage: 'There was a problem loading the events',
    responseName: 'events'
  });
};

var getServerSentEvents = function getServerSentEvents(dispatch) {
  currentSseTenant = (0, _tenantHelper.getTenantFromUrl)();

  if (eventSource != null) {
    eventSource.close();
    eventSource = null;
  }

  eventSource = new _eventSourcePolyfill.EventSourcePolyfill("".concat(env.REACT_APP_EVENT_API, "/events/notifications"), {
    headers: {
      Authorization: "Bearer ".concat(_apiServices.AuthService.getToken()),
      'X-Tenant': (0, _tenantHelper.getTenantFromUrl)()
    }
  });
  eventSource.addEventListener('open', function () {
    // if we reconnected right away we don't need to re grab the data
    if (reconnectAttempt > 1) {
      dispatch({
        type: types.RESET_EVENT_LIST
      });
      dispatchSearchEvents(dispatch, currentRequest, 0, currentSize * (currentPage + 1), currentSortStartDateDesc);
    }

    reconnectAttempt = 0;
  });
  eventSource.addEventListener('message', function (event) {
    if (event.data && isStringJson(event.data)) {
      var parsedJson = JSON.parse(event.data);

      if (parsedJson.event && isStringJson(parsedJson.event)) {
        parsedJson.event = JSON.parse(parsedJson.event);
      }

      if (parsedJson && parsedJson.event) {
        dispatch({
          type: types.EVENT_UPDATE,
          data: parsedJson,
          filter: currentRequest
        });
      }
    }
  });
  eventSource.addEventListener('error', function () {
    // close out the last connection
    eventSource.close();
    eventSource = null; // dispatch the connection error

    dispatch({
      type: types.EVENT_UPDATE_ERROR
    }); // let's try to reconnect

    if (reconnectAttempt < 6) {
      setTimeout(function () {
        reconnectAttempt += 1;
        getServerSentEvents(dispatch);
      }, reconnectAttempt === 0 ? 100 : 30000); // if this is first reconnect try, attempt right away, could be blue green deployment
    }
  });
};

exports.getServerSentEvents = getServerSentEvents;

var resetNewEvents = function resetNewEvents() {
  return {
    type: types.RESET_NEW_EVENTS
  };
};

exports.resetNewEvents = resetNewEvents;

var searchEvents = function searchEvents(searchEventsRequest, page, size, sortStartDateDesc, resetEventList) {
  return function (dispatch) {
    // If a user opens filter and applies without changing anything the request can be undefined
    var request = searchEventsRequest || _allEventsDashboard["default"].dashboardData;

    if (resetEventList === true) {
      dispatch({
        type: types.RESET_EVENT_LIST
      });
      reconnectAttempt = 0;

      if (eventSource === null || currentSseTenant !== (0, _tenantHelper.getTenantFromUrl)()) {
        getServerSentEvents(dispatch);
      }
    }

    currentRequest = request;
    currentPage = page;
    currentSize = size;
    currentSortStartDateDesc = sortStartDateDesc;
    dispatchSearchEvents(dispatch, request, page, size, sortStartDateDesc);
  };
};

exports.searchEvents = searchEvents;

var getAnalytics = function getAnalytics(searchEventsRequest) {
  return function (dispatch) {
    (0, _networkDispatcher.dispatchNetworkRequest)({
      dispatch: dispatch,
      requestType: types.EVENT_ANALYTICS_REQUESTED,
      successType: types.EVENT_ANALYTICS_SUCCESS,
      errorType: types.EVENT_ANALYTICS_ERROR,
      promise: _apiServices.EventService.getAnalytics(searchEventsRequest),
      defaultErrorMessage: 'There was a problem loading the analytics',
      responseName: 'analytics'
    });
  };
};

exports.getAnalytics = getAnalytics;

var addEvent = function addEvent(addEventRequest) {
  return function (dispatch) {
    (0, _networkDispatcher.dispatchNetworkRequest)({
      dispatch: dispatch,
      requestType: types.EVENT_ADD_REQUESTED,
      successType: types.EVENT_ADD_SUCCESS,
      errorType: types.EVENT_ADD_ERROR,
      promise: _apiServices.EventService.addEvent(addEventRequest),
      defaultErrorMessage: 'There was a problem creating the event',
      successMessage: 'Successfully created the event',
      responseName: 'newEvent'
    });
  };
};

exports.addEvent = addEvent;

var patchEvent = function patchEvent(id, request) {
  return function (dispatch) {
    dispatch({
      type: types.SELECTED_EVENT_ID_TO_UPDATE,
      eventId: id
    });

    var promise = _apiServices.EventService.patchEvent(id, request);

    (0, _networkDispatcher.dispatchNetworkRequest)({
      dispatch: dispatch,
      requestType: types.EVENT_PATCH_REQUESTED,
      successType: types.EVENT_PATCH_SUCCESS,
      errorType: types.EVENT_PATCH_ERROR,
      promise: promise,
      defaultErrorMessage: 'There was a problem updating the event',
      successMessage: 'Successfully updated the event',
      responseName: 'updatedEvent'
    });
    return promise;
  };
};

exports.patchEvent = patchEvent;

var setSelectedEvent = function setSelectedEvent(selectedEvent) {
  return {
    type: types.SELECTED_EVENT_CHANGED,
    selectedEvent: selectedEvent
  };
};

exports.setSelectedEvent = setSelectedEvent;

var getEvent = function getEvent(id) {
  return function (dispatch) {
    var promise = _apiServices.EventService.getEvent(id);

    (0, _networkDispatcher.dispatchNetworkRequest)({
      dispatch: dispatch,
      requestType: types.EVENT_REQUESTED,
      successType: types.EVENT_SUCCESS,
      errorType: types.EVENT_ERROR,
      promise: promise,
      defaultErrorMessage: 'There was a problem loading the event',
      responseName: 'event'
    });
    return promise;
  };
};

exports.getEvent = getEvent;

var addComment = function addComment(id, _ref) {
  var comment = _ref.comment;
  var successCallback = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function () {};
  return function (dispatch) {
    var promise = _apiServices.EventService.addComment(id, {
      comment: comment
    });

    promise.then(function () {
      successCallback();
    })["catch"](function () {});
    (0, _networkDispatcher.dispatchNetworkRequest)({
      dispatch: dispatch,
      requestType: types.EVENT_ADD_COMMENT_REQUESTED,
      successType: types.EVENT_ADD_COMMENT_SUCCESS,
      errorType: types.EVENT_ADD_COMMENT_ERROR,
      promise: promise,
      defaultErrorMessage: 'There was a problem adding the comment',
      responseName: 'newComment'
    });
  };
};

exports.addComment = addComment;

var addUpload = function addUpload(id, displayName, file) {
  var successCallback = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : function () {};
  return function (dispatch) {
    var promise = _apiServices.EventService.addUpload(id, displayName, file);

    promise.then(function () {
      successCallback();
    })["catch"](function () {});
    (0, _networkDispatcher.dispatchNetworkRequest)({
      dispatch: dispatch,
      requestType: types.EVENT_ADD_UPLOAD_REQUESTED,
      successType: types.EVENT_ADD_UPLOAD_SUCCESS,
      errorType: types.EVENT_ADD_UPLOAD_ERROR,
      promise: promise,
      defaultErrorMessage: 'There was a problem uploading the file',
      successMessage: 'Successfully uploaded the file',
      responseName: 'newEventUpload'
    });
  };
};

exports.addUpload = addUpload;

var changeStatus = function changeStatus(id, status) {
  var successCallback = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function () {};
  return function (dispatch) {
    dispatch({
      type: types.SELECTED_EVENT_ID_TO_UPDATE,
      eventId: id
    });

    var promise = _apiServices.EventService.changeStatus(id, status);

    promise.then(function () {
      successCallback();
    })["catch"](function () {});
    (0, _networkDispatcher.dispatchNetworkRequestDynamicSuccessDispatch)({
      dispatch: dispatch,
      requestType: types.EVENT_CHANGE_STATUS_REQUESTED,
      successDispatch: {
        type: types.EVENT_CHANGE_STATUS_SUCCESS,
        eventId: id
      },
      errorType: types.EVENT_CHANGE_STATUS_ERROR,
      promise: promise,
      defaultErrorMessage: 'There was a problem changing statuses',
      responseName: 'newStatus'
    });
  };
};

exports.changeStatus = changeStatus;

var getEventsExport = function getEventsExport(request) {
  return function (dispatch) {
    (0, _networkDispatcher.dispatchNetworkRequest)({
      dispatch: dispatch,
      requestType: types.EVENT_EXPORT_REQUESTED,
      successType: types.EVENT_EXPORT_SUCCESS,
      errorType: types.EVENT_EXPORT_ERROR,
      promise: _apiServices.EventService.getExport(request),
      defaultErrorMessage: 'There was a problem exporting the events',
      responseName: 'download'
    });
  };
};

exports.getEventsExport = getEventsExport;

var searchOverdueEvents = function searchOverdueEvents(request, page, size, sortStartDateDesc) {
  return function (dispatch) {
    (0, _networkDispatcher.dispatchNetworkRequest)({
      dispatch: dispatch,
      requestType: types.EVENT_SEARCH_OVERDUE_REQUESTED,
      successType: types.EVENT_SEARCH_OVERDUE_SUCCESS,
      errorType: types.EVENT_SEARCH_OVERDUE_ERROR,
      promise: _apiServices.EventService.searchEvents(_objectSpread(_objectSpread({}, request), {}, {
        pastDue: true
      }), page, size, sortStartDateDesc),
      defaultErrorMessage: 'There was a problem loading past due events',
      responseName: 'overdueEvents'
    });
  };
};

exports.searchOverdueEvents = searchOverdueEvents;

var getEventActivity = function getEventActivity(page, size) {
  return function (dispatch) {
    (0, _networkDispatcher.dispatchNetworkRequest)({
      dispatch: dispatch,
      requestType: types.EVENT_ACTIVITY_REQUESTED,
      successType: types.EVENT_ACTIVITY_SUCCESS,
      errorType: types.EVENT_ACTIVITY_ERROR,
      promise: _apiServices.EventService.getActivity('', page, size),
      defaultErrorMessage: 'There was a problem loading organization workflow activity',
      responseName: 'eventActivityPageable'
    });
  };
};

exports.getEventActivity = getEventActivity;